import Job from 'models/Job';
import JobCity from 'models/JobCity';

import { Props as JobBoxDescriptionProps } from 'components/modules/public/layout/jobs/JobBoxDescription';
import { Props as MediumJobBoxProps } from 'components/modules/public/layout/jobs/MediumJobBox';

import Component from './component';

export interface Props {
   job: Job;
   jobCity: JobCity;
   jobBoxCopy: MediumJobBoxProps;
   jobBoxDescriptionCopy: JobBoxDescriptionProps;
   applicationButtonVisible?: boolean;
   onApply: () => any;
}

Component.defaultProps = {};

export default Component;